var map = {
	"./Activate-pin.svg": 37160,
	"./Ipad.svg": 2173,
	"./Maintain_img.svg": 71066,
	"./More-Info-Icon-01.svg": 51569,
	"./Premvg.svg": 65480,
	"./Reload-Backward.svg": 62052,
	"./Reload-Forward.svg": 33046,
	"./about.png": 39866,
	"./add-name.svg": 31014,
	"./airplay.svg": 37753,
	"./alert.png": 66843,
	"./allBays-close.svg": 16170,
	"./allbay-arrow.svg": 34930,
	"./amazon-pay.svg": 61288,
	"./android-tv.svg": 50941,
	"./app-store.svg": 98614,
	"./apple-tv.svg": 18750,
	"./arrow-down.svg": 39225,
	"./arrow-up.svg": 77910,
	"./back.svg": 2444,
	"./backward.svg": 36050,
	"./bill-arrow1.svg": 49139,
	"./bill-arrow2.svg": 78240,
	"./bill-crose.svg": 60531,
	"./bill.svg": 70842,
	"./billing-bg.svg": 79498,
	"./billing.svg": 34254,
	"./camera1.svg": 96509,
	"./camera2.svg": 50238,
	"./child-lock-alert.png": 46938,
	"./child-lock.svg": 3047,
	"./chromecast.svg": 19394,
	"./contine-watch.svg": 41683,
	"./credit-card.svg": 55501,
	"./crome.svg": 99455,
	"./device.svg": 70851,
	"./docubytes.svg": 19415,
	"./download.svg": 82405,
	"./downloads-inn.svg": 85702,
	"./downloads.svg": 93708,
	"./email.svg": 98811,
	"./error.svg": 26217,
	"./fb.svg": 2261,
	"./fire-tv.svg": 92032,
	"./forward.svg": 50088,
	"./generate-pin.svg": 28342,
	"./gift-card.svg": 39466,
	"./google-play.svg": 78939,
	"./hd_new.svg": 92426,
	"./help-support.svg": 62126,
	"./help.svg": 63488,
	"./home.svg": 82928,
	"./icons8-facebook.svg": 34760,
	"./icons8-instagram.svg": 22640,
	"./icons8-linkedin.svg": 62682,
	"./icons8-twitterx.svg": 24819,
	"./icons8-youtube.svg": 86319,
	"./in.svg": 33584,
	"./insta.svg": 68094,
	"./iphone.svg": 39786,
	"./language.svg": 76527,
	"./laptop.svg": 72797,
	"./lg-tv.svg": 19057,
	"./like-red.svg": 96810,
	"./like.svg": 80880,
	"./live-tv.svg": 66030,
	"./lock.svg": 38316,
	"./log-out.svg": 5434,
	"./mail-right-arrow.svg": 19889,
	"./manage-membership.svg": 7057,
	"./manage-profile.svg": 81316,
	"./mask.svg": 58213,
	"./more-info.svg": 50291,
	"./net-banking.svg": 23783,
	"./next-slick.svg": 26269,
	"./notifications-desk.svg": 90083,
	"./notifications.svg": 38551,
	"./np-language.svg": 79390,
	"./password-exposed.svg": 12169,
	"./password-hidden.svg": 27211,
	"./pause.svg": 58185,
	"./paytm.png": 63422,
	"./phone.svg": 89355,
	"./play-2.svg": 582,
	"./play.svg": 98355,
	"./play2.svg": 47723,
	"./premium-red.svg": 44086,
	"./premium-red1.svg": 42763,
	"./premium-yellow.svg": 75373,
	"./prev-slick.svg": 74865,
	"./privacy-policy.svg": 12662,
	"./profile-desk.svg": 37970,
	"./profile.svg": 42028,
	"./promocode-close.svg": 31442,
	"./quality.svg": 22424,
	"./red-right-arrow.svg": 7507,
	"./red-right.svg": 19399,
	"./remove-list.svg": 18478,
	"./right-arrow.svg": 95233,
	"./roku.svg": 87832,
	"./search-1.svg": 65635,
	"./search-close.svg": 10266,
	"./search-desk.svg": 89017,
	"./search.svg": 39161,
	"./select-arrow-2.svg": 72356,
	"./select-arrow.svg": 22709,
	"./share-hover.svg": 29239,
	"./share-inn.svg": 85888,
	"./share.svg": 98230,
	"./signUP-membership-bg.svg": 69390,
	"./skip-arrow.svg": 79084,
	"./smart-tv.svg": 80787,
	"./speed.svg": 61082,
	"./star-preum.svg": 14403,
	"./subtitles.svg": 52916,
	"./swipe-btn.svg": 62226,
	"./swipe.svg": 5241,
	"./temp69-po-btn.svg": 82753,
	"./terms-of-use.svg": 91158,
	"./tick-membership.svg": 51459,
	"./tick.svg": 68150,
	"./tik-radio.svg": 79681,
	"./trailer-btn.svg": 58269,
	"./trailer-btnRed.svg": 89538,
	"./tube.svg": 82419,
	"./tv.svg": 38099,
	"./tw.svg": 7522,
	"./upi.png": 50629,
	"./wallets.svg": 37677,
	"./watch-lists.svg": 64026,
	"./watchlist-btn.svg": 15617,
	"./watchlist-inn.svg": 54220,
	"./watchlist.svg": 18266,
	"./wave-left-desk.svg": 79566,
	"./wave-left.svg": 96424,
	"./wave-right-desk.svg": 21059,
	"./wave-right-red.svg": 57557,
	"./wave-right.svg": 28663,
	"./wave-right1.svg": 89508,
	"./whatsapp.svg": 68959,
	"./whatsapp1.svg": 95356,
	"./wincup-white.svg": 10007,
	"./wincup.svg": 60151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82638;